import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
/**
 * Configuration for requesting a cost waiver when ordering
 */
export class CostWaiverConfiguration {
    /**
     * @param enabled Indicates whether a cost waiver can be requested when ordering
     * @param optionText The text to appear next to the cost waiver option
     * @param documentText The text describing documents needed for proof of eligibility
     * @param documentIsOptional Indicates if the document upload is optional
     */
    constructor(enabled, optionText, documentText, documentIsOptional) {
        this.enabled = enabled;
        this.optionText = optionText;
        this.documentText = documentText;
        this.documentIsOptional = documentIsOptional;
    }
}
CostWaiverConfiguration.MAX_OPTION_TEXT_LENGTH = 100;
CostWaiverConfiguration.MAX_DOCUMENT_TEXT_LENGTH = 1000;
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CostWaiverConfiguration.prototype, "enabled", void 0);
__decorate([
    Length(0, CostWaiverConfiguration.MAX_OPTION_TEXT_LENGTH),
    __metadata("design:type", String)
], CostWaiverConfiguration.prototype, "optionText", void 0);
__decorate([
    Length(0, CostWaiverConfiguration.MAX_DOCUMENT_TEXT_LENGTH),
    __metadata("design:type", String)
], CostWaiverConfiguration.prototype, "documentText", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CostWaiverConfiguration.prototype, "documentIsOptional", void 0);
export const DEFAULT_COST_WAIVER_CONFIGURATION = new CostWaiverConfiguration(false, 'I am eligible for a cost waiver', 'Please upload proof of eligibility.', false);
